// This file contains the hover components for the cards in the dashboard

import { CardDropdownButton, CardDropdownOpenFolderButton } from "../../../../Buttons"

/** This component is for the Dashboard Cards that appear in the Dashboard */
function CardDropdownBase({children}: {children: React.ReactNode}){
    return (
        <div className="grid items-center justify-center grid-cols-2 gap-2 ">
            {children}
        </div>
    )
}

type CardDropdownProjectProps = {
    edit_project_route: string,
    create_task_route: string,
    assign_tasks_route: string,
    folder_path: string,
    create_rfi_route: string,
    create_submittal_route: string
}

// These are the hover components for different cards
export function CardDropdownProject({edit_project_route, create_task_route, assign_tasks_route, folder_path, create_rfi_route, create_submittal_route } : CardDropdownProjectProps ){
    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit Project" route={edit_project_route} />
            <CardDropdownButton text="Create Custom Task" route={create_task_route} />
            <CardDropdownButton text="Assign Tasks" route={assign_tasks_route} />
            <CardDropdownButton text="Create RFI" route={create_rfi_route} />
            <CardDropdownButton text="Create Submittal" route={create_submittal_route} />
            <CardDropdownOpenFolderButton folder_path={folder_path} />
        </CardDropdownBase>
    )
}

type CardDropdownTaskProps = {
    edit_task_route: string,
    mark_as_completed_fn: () => void,
    mark_as_pinged_fn: () => void,
    folder_path?: string
}

export function CardDropdownTask({edit_task_route, mark_as_completed_fn, mark_as_pinged_fn, folder_path} : CardDropdownTaskProps){
    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit Task" route={edit_task_route} />
            <CardDropdownButton text="Mark as Completed" onClick={mark_as_completed_fn} />
            <CardDropdownButton text="Clear Ping Status" onClick={mark_as_pinged_fn} />
            {folder_path && <CardDropdownOpenFolderButton folder_path={folder_path} />}
        </CardDropdownBase>
    )
}

type CardDropdownSubmittalProps = {
    edit_submittal_route: string,
    folder_path: string,
    parent_project_folder_location: string,
    category: string,
    mark_as_completed_fn: () => void
}

export function CardDropdownSubmittal({edit_submittal_route, folder_path, parent_project_folder_location, mark_as_completed_fn, category} : CardDropdownSubmittalProps){
    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit Submittal" route={edit_submittal_route} />
            <CardDropdownButton text="Mark as Closed" onClick={mark_as_completed_fn} />
            <CardDropdownOpenFolderButton folder_path={folder_path} label="Open Submittal Folder" />
            <CardDropdownOpenFolderButton folder_path={parent_project_folder_location} label="Open Project Folder" />
            <CardDropdownOpenFolderButton folder_path={`${parent_project_folder_location}/Submittals/${category}`} label={`Open ${category} Folder`} />
        </CardDropdownBase>
    )
}

type CardDropdownRFIProps = {
    edit_rfi_route: string,
    folder_path: string,
    parent_project_folder_location: string,
    mark_as_closed_fn: () => void,
}

export function CardDropdownRFI({edit_rfi_route, folder_path, parent_project_folder_location, mark_as_closed_fn} : CardDropdownRFIProps){

    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit RFI" route={edit_rfi_route} />
            <CardDropdownButton text="Mark as Closed" onClick={mark_as_closed_fn} />
            <CardDropdownOpenFolderButton folder_path={folder_path} label="Open RFI Folder" />
            <CardDropdownOpenFolderButton folder_path={parent_project_folder_location} label="Open Project Folder" />
        </CardDropdownBase>
    )
}

type CardDropdownInvoiceProps = {
    edit_invoice_route: string,
    mark_as_sent_fn: () => void,
    mark_as_sent_to_quickbooks_fn: () => void
}


export function CardDropdownInvoice({edit_invoice_route, mark_as_sent_fn, mark_as_sent_to_quickbooks_fn} : CardDropdownInvoiceProps){
    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit Invoice" route={edit_invoice_route} />
            <CardDropdownButton text="Mark as Sent" onClick={mark_as_sent_fn} />
            <CardDropdownButton text="Mark as Sent to Quickbooks" onClick={mark_as_sent_to_quickbooks_fn} />
        </CardDropdownBase>

    )
}

type CardDropdownAssignmentProps = {
    edit_assignment_route: string,
    mark_as_completed_fn: () => void,
}

export function CardDropdownAssignment({edit_assignment_route, mark_as_completed_fn} : CardDropdownAssignmentProps){
    return (
        <CardDropdownBase>
            <CardDropdownButton text="Edit Assignment" route={edit_assignment_route} />
            <CardDropdownButton text="Mark as Completed" onClick={mark_as_completed_fn} />
        </CardDropdownBase>
    )
}